/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { strings } from '../../resources/strings';
import { getMatchUrl } from '../../utils/routes';
import { useTicketConfig } from '../../hooks/ticket';

function MatchRow({ match, markMatchAsHighlighted, highlight }) {
  const {
    homeTeamName,
    visitingTeamName,
    status,
    homeTeamScore,
    visitingTeamScore,
    id,
    homeTeamAbbrv,
  } = match;

  const [ticketConfig] = useTicketConfig(homeTeamAbbrv);

  const ticketUrl = _.get(ticketConfig, 'ticketUrl', '');

  const getResultStyling = () => {
    if (status === 'FINISHED') {
      return 'score-result';
    }

    if (status === 'ONGOING') {
      return 'score-result badge badge--comp-pink';
    }

    return 'score-result';
  };

  const getButtonText = () =>
    status === 'FINISHED' ? 'Summering' : 'Följ match';

  const bgStyle = highlight
    ? 'col-12 px-2 px-sm-4 py-2 data-container__row--transparent-primary-yellow data-container__row--has-hover cursor-pointer'
    : 'col-12 px-2 px-sm-4 py-2 data-container__row data-container__row--has-hover cursor-pointer';

  const showNavigationToMatch = ![
    'superettanQualification',
    'allsvenskanQualification',
  ].includes(match?.leagueName);

  return (
    <div className={bgStyle}>
      <div className="row" onClick={() => markMatchAsHighlighted(id)}>
        <div className="col-8 d-flex align-items-center">
          <p className="fw-bold text-small-extra text-sm-regular">
            {homeTeamName} - {visitingTeamName}
          </p>
        </div>
        <div className="col-4 d-flex justify-content-end align-items-center gap-2">
          {status !== 'UPCOMING' && (
            <p className="text-small text-color-comp-gray-1 fw-bold d-none d-sm-inline-block">
              {strings?.MATCH_STATUS[status]}
            </p>
          )}
          {status !== 'UPCOMING' && (
            <>
              <div className="d-flex gap-1 ">
                <span className={getResultStyling()}>{homeTeamScore}</span>
                <span className={getResultStyling()}>{visitingTeamScore}</span>
              </div>
              {showNavigationToMatch && (
                <a
                  className="button button--primary button--small d-inline-block text-nowrap"
                  href={getMatchUrl(
                    match.configSeasonStartYear,
                    match.id,
                    homeTeamName,
                    visitingTeamName
                  )}
                >
                  {getButtonText()}
                </a>
              )}
            </>
          )}
          {status === 'UPCOMING' && (
            <>
              {showNavigationToMatch && (
                <a
                  className="button button--primary button--small d-inline-block"
                  href={getMatchUrl(
                    match.configSeasonStartYear,
                    match.id,
                    homeTeamName,
                    visitingTeamName
                  )}
                >
                  Inför
                </a>
              )}
              {ticketUrl && (
                <a
                  className="button button--primary button--small d-inline-block"
                  href={ticketUrl}
                >
                  Biljett
                </a>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

MatchRow.propTypes = {
  match: PropTypes.shape({
    homeTeamName: PropTypes.string,
    visitingTeamName: PropTypes.string,
    status: PropTypes.string,
    homeTeamScore: PropTypes.number,
    visitingTeamScore: PropTypes.number,
  }).isRequired,
};

export default MatchRow;
